export const MAX_SELECTED_WEEKS = 9;
